<script setup lang="ts">
import TheUserMenu from "./TheUserMenu.vue";
import TheNavDrawer from "./TheNavDrawer.vue";
import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useUserStore } from '../store/user';
import { useSearchStore } from '../store/search';
import { mdiMagnify } from '@mdi/js';

const userStore = useUserStore();
const searchStore = useSearchStore();


const showDrawer = ref(false);
const { user } = storeToRefs(userStore);
const { showSearch } = storeToRefs(searchStore);

function onShowSearch() {
    showSearch.value = true;
}

</script>

<template>
<v-app-bar :elevation="0">
  <template v-slot:prepend>
    <v-app-bar-nav-icon @click.stop="showDrawer = !showDrawer"></v-app-bar-nav-icon>
  </template>

  <v-app-bar-title class="site-title"><router-link :to="`/`" class="name">Clicjar</router-link></v-app-bar-title>

  <template v-slot:append>
    <v-btn 
        :icon=mdiMagnify
        @click="onShowSearch"></v-btn>
    <TheUserMenu/>
  </template>
</v-app-bar>

<TheNavDrawer :show-drawer="showDrawer" :user="user"/>
</template>

<style scoped>
:deep(.v-toolbar__content) {
    max-width: 1200px;
    margin: 0 auto;
    width: 100%;
    padding: 0 1.5rem;
}
.header {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 40px;
}
.brand {
    display: flex;
    align-items: center;
    gap: 10px;
}
.logo {
    width: 40px;
    height: 40px;
}
#app .site-title {
    text-align: left;
}
#app .site-title .name {
    font-size: 38px;
    font-family: "Sacramento", cursive;
    font-weight: 400;
    font-style: normal;
    color: var(--v-theme-primary);
    text-align: left;
    line-height: 57px;
}
.user {
    display: flex;
    align-items: center;
}
</style>